


import QuickBite from './QuickBite';

const CategoryListItem = (props) => {

  const { addItemToCart, business, categories, category, index, hideZero, optionsFirst, isSelected,
    isCollapsed,
    removeItem,
    setItemQuantity,
    selectedMenu,
    pushCategory,
    setSelectedCategory } = props;


  const [isOpen, setOpen] =React.useState(isCollapsed == false)

  const _productIsOffer = (product) => {
    // if the product id is in an offer in the location
    if (selectedMenu.Location == null || selectedMenu.Location.Campaigns == null) {
      return false
    }
    let found = selectedMenu.Location.Campaigns.find((offer) => offer.productId == product.id)

    return found
  }

  const isVisible = (p) => {

    if (hideZero && p.managed === true && p.quantity <= 0) {
      // product inventory is managed
      return false
    }

    return p.available === true //&& p.restricted != true
  }

  let showData = isOpen && isSelected

  const categoryHeaderImage = () => {
    if (category.photo != null && category.photo != "") {
      return <img src={category.photo} width={100} />
    }

    // if the business is a services business use services
    if (category.Services && category.Services.length > 0) {
      let services = category.Services.filter((p) => p.photo != "")
      if (services.length > 0) {
        // use a random image from the products
        var item = services[Math.floor(Math.random() * services.length)];
        return <img src={item.photo} width={100} />
      }
    }

    // otherwise use a product photo
    if (category.Products && category.Products.length > 0) {
      let products = category.Products.filter((p) => p.photo != "")
      if (products.length > 0) {
        // use a random image from the products
        var item = products[Math.floor(Math.random() * products.length)];
        return <img src={item.photo} width={100} />
      }
    }

    return <img src={business.photo} width={100} />
  }

  const titleElement = () => {
    //console.log("titleElement", showData, category, business)

    if (showData) {
      // this applies when there is no selected category and the
      // category is displayed open, e.g. show the products
      if (category.button != "") {

        return (
          <h3 className="mt-1 category-button centered" onClick={() => setOpen(false)}>
            <img src={category.button} />
          </h3>
        )
      }

      return (
        <h5 className="mt-1 category-header">
          <div>

            {categoryHeaderImage()}

            <span>
              {category.name} <br />
              {category.description}
            </span>
          </div>

          <div style={{
            margin: 'auto',
            marginRight: 10,
            marginLeft: 10
          }}>
            <span className="category-expander" onClick={() => setOpen(false)}>
              <i className="fa fa-chevron-down fa-2x" aria-hidden="true" style={{ color: '#999' }}></i>
            </span>

          </div>

        </h5>
      )
    }

    // showData is false so we just display the category header

    // If the category has a button photo, then display the button photo.
    if (category.button != "") {

      return (
        <h3 className="mt-1  category-button centered" onClick={() => pushCategory(category)}>
          <img src={category.button} />
        </h3>
      )
    }

    // Otherwise, display the category image and the category name and description.
    return (
      <h3 className="mt-1 category-header" onClick={() => pushCategory(category)}>

        <div>
          {categoryHeaderImage()}
        </div>

        <div style={{
          margin: 'auto',
          marginRight: 5,
          marginLeft: 5
        }}>
          {category.name} <br />
          {category.description}
          {/*
           <small className="h6 text-black-50">
          {data.Products.filter((p) => p.available === true).length} {tr('ITEMS')}</small>
        */}
        </div>

        <div style={{
          margin: 'auto',
          marginRight: 10,
          marginLeft: 10
        }}>

          <span className="category-expander" >
            <i className="fa fa-chevron-left fa-1x" aria-hidden="true" style={{ color: '#999' }}></i>
          </span>

        </div>


      </h3>
    )
  }

  //console.log("category", category.name, category.Products)

  return (<div key={index} id={`category_${category.name}`} className="px-1" >

    {titleElement()}
    {showData &&
      <div className ="col-md-12" style={{
        padding: 4
      }}>

        <div id={`category_content_${category.id}`}
          className="category-content rounded border shadow-sm mb-1">
          {category.Products.filter((p) => isVisible(p)).map((product, i) => {
            let isOffer = _productIsOffer(product)

            return (<QuickBite
              key={i}
              product={product}
              categories={categories}
              id={product.id}
              /* itemClass="menu-list" */
              image={product.photo}
              title={product.name}
              price={product.price}
              hasOrdering={true}
              priceUnit='$'
              isOffer={isOffer}
              getValue={(args) => {
                //console.log("getValue add to cart", product.id, args);
                if (args.quantity === 1) {
                  // make a copy of the object
                  let newItem = Object.assign({}, product);
                  newItem.quantity = 1
                  newItem.menu_id = product.menu_id || selectedMenu.id
                  addItemToCart(newItem, args);
                } else if (args.quantity === 0) {
                  removeItem(product, args);
                } else {
                  setItemQuantity(product, args.quantity);
                }

              }}
              detailColour={'#F1AD3E'}
              optionsFirst={optionsFirst}
            />)
          })}

        </div>

      </div>
    }
  </div>)
}

export default CategoryListItem